import { LazyModule, registerLazyOrchestrator } from 'owa-bundling';
import { onSelectFolderComplete } from 'owa-mail-actions/lib/mailListActions';
import deleteItemsStoreUpdate from 'owa-mail-actions/lib/triage/deleteItemsStoreUpdate';
import markItemsAsPinnedStoreUpdate from 'owa-mail-actions/lib/triage/markItemsAsPinnedStoreUpdate';
import markConversationsAsPinnedStoreUpdate from 'owa-mail-actions/lib/triage/markConversationsAsPinnedStoreUpdate';
9;
import removeRowsFromListViewStore from 'owa-mail-actions/lib/triage/removeRowsFromListViewStore';
import onSendMessageSucceeded from 'owa-mail-compose-store/lib/actions/onSendMessageSucceeded';
import { onDismissNudgeInfoBar } from 'owa-mail-reading-pane-store/lib/infoBar/actions/onDismissNudgeInfoBar';

const lazyModule = new LazyModule(() => import(/* webpackPrefetch: true */ './lazyIndex'));

registerLazyOrchestrator(onSelectFolderComplete, lazyModule, m => m.getNudgesOrchestrator);

registerLazyOrchestrator(
    onDismissNudgeInfoBar,
    lazyModule,
    m => m.removeNudgeOnDismissOrchestrator
);

registerLazyOrchestrator(
    deleteItemsStoreUpdate,
    lazyModule,
    m => m.removeNudgeOnItemDeleteStoreUpdateOrchestrator
);

registerLazyOrchestrator(
    removeRowsFromListViewStore,
    lazyModule,
    m => m.removeNudgeOnRowsDeleteStoreUpdateOrchestrator
);

registerLazyOrchestrator(
    markItemsAsPinnedStoreUpdate,
    lazyModule,
    m => m.removeNudgeOnItemsPinnedStoreUpdateOrchestrator
);

registerLazyOrchestrator(
    markConversationsAsPinnedStoreUpdate,
    lazyModule,
    m => m.removeNudgeOnConversationsPinnedStoreUpdateOrchestrator
);

registerLazyOrchestrator(
    onSendMessageSucceeded,
    lazyModule,
    m => m.removeNudgeOnReplyOrReplyAllOrForwardOrchestrator
);
